import RestService from '../services/rest';

async function getOutboundOrdersList(tableParams) {
  return RestService.postAuthenticated('outboundWaves/outboundOrdersList', tableParams);
}

async function generateWaves(outboundOrderIds) {
  return RestService.postAuthenticated('outboundWaves/generate', { outboundOrderIds });
}

async function getOutboundWavesByDate(filterStartDate, filterEndDate) {
  return RestService.getAuthenticated(`outboundWaves/wavesByDate?filterStartDate=${filterStartDate}&filterEndDate=${filterEndDate}`);
}

// BEES-3944 - uma onda no formato da lista do monitor, para atualizar so a
// linha afetada apos eliminar um documento ou uma onda.
async function getOutboundWaveMonitor(outboundWaveId) {
  return RestService.getAuthenticated('outboundWaves/waveMonitor', { outboundWaveId });
}

async function getWaveDocuments(outboundWaveId) {
  return RestService.getAuthenticated('outboundWaves/waveDocuments', { outboundWaveId });
}

async function getOpenWaveList() {
  return RestService.getAuthenticated('outboundWaves/openWave');
}

async function addOrderToWave(rangeCode, priorityCode, loadNumber) {
  return RestService.putAuthenticated('outboundWaves/addOrder', { rangeCode, priorityCode, loadNumber });
}

async function startSeparation(outboundWaveId) {
  return RestService.putAuthenticated('outboundWaves/startSeparation', { outboundWaveId });
}

async function updateWaveAndDocuments(outboundRangeId, outboundWaveId) {
  return RestService.putAuthenticated('outboundWaves/updateWaveAndDocuments', { outboundRangeId, outboundWaveId });
}

async function getOutboundWavesProductsList(outboundWaveId) {
  return RestService.getAuthenticated(`outboundWaves/productsList?outboundWaveId=${outboundWaveId}`);
}

async function outboundWavesProductEan(ean, productCode) {
  return RestService.getAuthenticated('outboundWaves/ProductEan', { ean, productCode });
}

async function getOptionsPriorities() {
  return RestService.getAuthenticated('priorities/list/options');
}

export default {
  getOutboundOrdersList,
  getOutboundWaveMonitor,
  generateWaves,
  getOpenWaveList,
  addOrderToWave,
  startSeparation,
  getOutboundWavesProductsList,
  outboundWavesProductEan,
  getOutboundWavesByDate,
  getWaveDocuments,
  updateWaveAndDocuments,
  getOptionsPriorities,
};
